export default {
    URL: 'http://myanpr.in:5200/api/v1/',
    LOC_NAME: 'taj',
    LOCATION: 'Taj Hotels',
    ORG_CODE: 'TAJH'
}
